import SinglePage, { H2, Paragraph } from "../single-page/single-page";
import { email, singlePrice } from "../../envs";
import { Helmet } from "react-helmet";

function Regulations() {
    return (
        <SinglePage title="Regulamin">
            <Helmet>
                <title>Regulamin - geoksiegi.pl</title>
                <meta
                    name="description"
                    content="Zapoznaj się z regulaminem serwisu geoksiegi.pl, który określa zasady korzystania z platformy umożliwiającej wyszukiwanie numerów ksiąg wieczystych oraz realizację transakcji."
                />
                <meta
                    name="keywords"
                    content="regulamin, geoksiegi.pl, księgi wieczyste, numer księgi, wyszukiwanie ksiąg wieczystych, warunki korzystania, serwis"
                />
            </Helmet>
            <div className="regulamin">
                <H2>1. Postanowienia ogólne</H2>
                <Paragraph>
                    Niniejszy regulamin określa zasady korzystania z serwisu <strong>geoksiegi.pl</strong> (dalej
                    „Serwis”), który umożliwia wyszukiwanie numerów ksiąg wieczystych dla działek, budynków, lokali, garaży
                    oraz mieszkań. Korzystając z Serwisu, Użytkownik akceptuje niniejsze warunki.
                </Paragraph>

                <H2>2. Definicje</H2>
                <ul>
                    <li>
                        - <strong>Serwis:</strong> Platforma internetowa dostępna pod adresem geoksiegi.pl, umożliwiająca
                        wyszukiwanie numerów ksiąg wieczystych.
                    </li>
                    <li>
                        - <strong>Użytkownik:</strong> Każda osoba fizyczna lub prawna korzystająca z Serwisu.
                    </li>
                    <li>
                        - <strong>Konto:</strong> Profil utworzony przez Użytkownika w Serwisie, umożliwiający dostęp do
                        dodatkowych funkcji i pakietów.
                    </li>
                    <li>
                        - <strong>Usługa:</strong> Świadczenie usług polegających na wyszukiwaniu numerów ksiąg wieczystych, w
                        tym możliwość zakupu pojedynczego numeru księgi ({singlePrice} zł) bez rejestracji oraz korzystanie z pakietów
                        dostępnych dla zarejestrowanych Użytkowników.
                    </li>
                </ul>

                <H2>3. Zakres usług</H2>
                <Paragraph>Serwis umożliwia:</Paragraph>
                <ul>
                    <li>
                        - Wyszukiwanie numerów ksiąg wieczystych na podstawie adresu, identyfikatora działki lub numeru
                        działki.
                    </li>
                    <li>
                        - Zakup pojedynczego numeru księgi wieczystej bez konieczności rejestracji – cena wynosi {singlePrice} zł.
                    </li>
                    <li>
                        - Korzystanie z pakietów usług dostępnych dla użytkowników, którzy założą konto w Serwisie.
                    </li>
                </ul>

                <H2>4. Rejestracja i korzystanie z Serwisu</H2>
                <Paragraph>
                    Korzystanie z podstawowych funkcji Serwisu jest możliwe bez rejestracji. Aby uzyskać dostęp do
                    dodatkowych funkcjonalności, takich jak zakup pakietów, Użytkownik powinien założyć konto. Rejestracja
                    jest bezpłatna, a Użytkownik zobowiązany jest do podania prawidłowych i aktualnych danych.
                </Paragraph>

                <H2>5. Płatności i realizacja transakcji</H2>
                <Paragraph>
                    Transakcje dokonywane w Serwisie są realizowane za pomocą systemu płatności online. Cena pojedynczego
                    wyszukiwania numeru księgi wynosi {singlePrice} zł, a ceny pakietów usług są określone w cenniku dostępnym w
                    Serwisie. Realizacja płatności odbywa się zgodnie z zasadami operatora płatności.
                </Paragraph>

                <H2>6. Reklamacje</H2>
                <Paragraph>
                    Reklamacje dotyczące świadczenia usług w Serwisie należy zgłaszać na adres e-mail: <strong>{email}</strong>.
                    Reklamacje są rozpatrywane przez Administratora Serwisu w terminie przewidzianym przepisami prawa. W przypadku
                    pozytywnego rozpatrzenia reklamacji Użytkownik ma prawo żądać zwrotu wniesionej opłaty lub ponownego wykonania
                    usługi. Po prawidłowym wykonaniu usługi Użytkownik traci prawo do odstąpienia od umowy, a zakup pakietu usług po
                    wykorzystaniu przynajmniej jednego kredytu wyłącza możliwość odstąpienia od umowy.
                </Paragraph>

                <H2>7. Odpowiedzialność</H2>
                <Paragraph>
                    Serwis dokłada wszelkich starań, aby informacje udostępniane za jego pośrednictwem były aktualne i poprawne,
                    jednak nie gwarantuje bezbłędności danych. Administrator Serwisu nie ponosi odpowiedzialności za szkody wynikłe
                    z korzystania z Serwisu, a Użytkownik korzysta z niego na własne ryzyko.
                </Paragraph>

                <H2>8. Prawa i obowiązki Użytkownika</H2>
                <Paragraph>
                    Użytkownik zobowiązuje się do korzystania z Serwisu zgodnie z obowiązującymi przepisami prawa oraz niniejszym regulaminem. Zabrania się:
                </Paragraph>
                <ul>
                    <li>- Wykorzystywania Serwisu do celów niezgodnych z prawem.</li>
                    <li>- Próby uzyskania nieautoryzowanego dostępu do systemu lub kont innych Użytkowników.</li>
                    <li>- Publikowania treści naruszających prawa osób trzecich.</li>
                </ul>

                <H2>9. Polityka Prywatności</H2>
                <Paragraph>
                    Informacje dotyczące przetwarzania danych osobowych znajdują się w <strong>Polityce Prywatności</strong>,
                    która stanowi integralną część niniejszego regulaminu.
                </Paragraph>

                <H2>10. Postanowienia końcowe</H2>
                <Paragraph>
                    Niniejszy regulamin wchodzi w życie z dniem publikacji w Serwisie. Administrator zastrzega sobie prawo do
                    wprowadzania zmian w regulaminie. Aktualna wersja regulaminu będzie dostępna w Serwisie, a dalsze korzystanie
                    z Serwisu po wprowadzeniu zmian oznacza akceptację nowego regulaminu.
                </Paragraph>
            </div>
        </SinglePage>
    );
}

export default Regulations;
